const ROUTES = {
    LOGIN: '/login',
    REGISTER: '/create-user',
    CREATE_COMPANY: '/create-company',
    HOME: '/',
    CALL_DETAILS: '/call/:id',
    PROFILE: '/profile',
    CREATE_PASSWORD: '/set-password',
    RESET_PASSWORD_EMAIL: '/reset-password-email',
    CHECK_LIST: '/check-list',
    DASHBOARD: '/dashboard',
    BILLING: '/billing',
    CHECK_LIST_AUDIT: '/check-list-audit',
    CHECKLIST_MANAGEMENT: '/checklist-management',
    CHECKLIST_MANAGEMENT_DETAILS: '/checklist-management/:id',
}

export default ROUTES;
